











































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { Route } from 'vue-router'

import {
  ConfirmLeaveModal,
  NetworkErrorEmptyState,
  PortionForm,
  VsLoading
} from '@/components'

import { MobileLayout } from '@/layouts/components'

import {
  ActionButton,
  AsyncState,
  ModalState,
  Portion,
  PortionContext,
  PortionResourcePayload
} from '@/models'

@Component({
  components: {
    ConfirmLeaveModal,
    MobileLayout,
    NetworkErrorEmptyState,
    PortionForm,
    VsLoading
  }
})
export default class PortionDetails extends Vue {
  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  @Prop({ type: Number, required: true })
  readonly itemId!: number

  @Prop({ type: Number, required: true })
  readonly portionId!: number

  loadState = new AsyncState()
  updatePortionState = new AsyncState()
  confirmLeaveState = new ModalState()

  data: PortionResourcePayload | null = null
  isValid = false
  previousRoute: string | null = null

  get buttons (): ActionButton[] {
    if (this.portion === null) {
      return []
    }

    return [
      {
        text: 'Salvar',
        handler: this.handleSubmit,
        isDisabled: !this.hasChanges || !this.isValid || this.updatePortionState.isPending
      }
    ]
  }

  get context (): PortionContext {
    return {
      id: this.portionId,
      itemId: this.itemId,
      itemGroupId: this.itemGroupId
    }
  }

  get hasChanges () {
    const data = this.data
    const portion = this.portion

    return data !== null && portion !== null && (
      data.name !== portion.name ||
      data.price !== portion.price ||
      data.isAvailable !== portion.isAvailable
    )
  }

  get portion (): Portion | null {
    return this.portionByContext(this.context)
  }

  @Getter('menu/portionByContext')
  readonly portionByContext!: (context: PortionContext) => Portion | null

  @Action('menu/loadPortion')
  loadPortion!: (context: PortionContext) => Promise<void>

  @Action('menu/updatePortion')
  updatePortion!: (data: { id: number; payload: PortionResourcePayload }) => Promise<void>

  beforeRouteEnter (to: Route, from: Route, next: Function) {
    next((vm: this) => {
      vm.previousRoute = from.name ?? null
    })
  }

  async created () {
    if (this.portion === null) {
      await this.reload()
    } else {
      this.loadState.touch()
    }

    if (this.portion) {
      this.data = {
        itemId: this.itemId,
        name: this.portion.name,
        price: this.portion.price,
        isAvailable: this.portion.isAvailable
      }
    }
  }

  async reload () {
    try {
      await this.loadState.handle(
        this.loadPortion(this.context)
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleSubmit () {
    if (this.data === null || !this.hasChanges || !this.isValid) {
      return
    }

    try {
      await this.updatePortionState.handle(
        this.updatePortion({
          id: this.portionId,
          payload: this.data
        })
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  handleGoBack () {
    if (this.hasChanges) {
      this.confirmLeaveState.isActive = true
    } else {
      this.goBack()
    }
  }

  goBack () {
    if (this.previousRoute === 'ItemDetails') {
      this.$router.replace({ name: 'Portions' })
    } else {
      this.$router.back()
    }
  }
}
